<template>
  <el-dialog
    :title="model.id ? '编辑基地' : '添加基地'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="基地名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { baseCreate, baseUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      loading: false,
      rules: {
        name: [{ required: true, message: '请填写名称' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await baseUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await baseCreate(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>